import styled from "@emotion/styled"
import type { IconName } from "@porsche-design-system/components-react"
import { PIcon } from "@porsche-design-system/components-react"
import type { PropsWithChildren } from "react"
import tinycolor from "tinycolor2"
import { shouldForwardProp } from "src/common/shouldForwardProp"

export const SmallIconOverlay = ({
	backgroundHexCode,
	children,
	icon,
	visible,
}: PropsWithChildren<{
	backgroundHexCode: string
	icon: IconName
	visible: boolean
}>) => {
	const brightness = tinycolor(backgroundHexCode).getBrightness()
	return (
		<Layout>
			{visible && <StyledIcon name={icon} size="sm" color="inherit" $isBright={brightness > 160} />}
			{children}
		</Layout>
	)
}

const Layout = styled.div`
	display: flex;
`

const StyledIcon = styled(PIcon, { shouldForwardProp })<{ $isBright: boolean }>`
	margin-inline-end: -24px;
	z-index: 2;
	filter: ${({ $isBright }) => ($isBright ? "invert(0%) sepia(0%) saturate(7500%) hue-rotate(272deg) brightness(108%) contrast(108%)" : "invert(100%) sepia(0%) saturate(1%) hue-rotate(306deg) brightness(108%) contrast(101%)")};
`
